







































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import util from "@/lib/util";
class CreateTimeType {
  startTime: string = "";
  endTime: string = "";
}
@Component({
  components: {},
})
export default class CreateCouponCourt extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: Number, default: 0 }) offerDateSlotId: number;

  createTime: CreateTimeType = new CreateTimeType();
  id: number = 0;
  title: string = "添加时间段";
  save() {
    (this.$refs.createTimeForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let type =
          this.id > 0 ? "offerTimeSlot/update" : "offerTimeSlot/create";
        let data = {
          startTime: this.createTime.startTime,
          endTime: this.createTime.endTime,
          offerDateSlotId: this.$props.offerDateSlotId,
        };
        if (this.id > 0) {
          data["id"] = this.id;
        }
        await this.$store.dispatch({
          type: type,
          data,
        });
        (this.$refs.createTimeForm as any).resetFields();
        this.$emit("input", false);
        this.$emit("save-success");
      }
    });
  }

  get list() {
    return this.$store.state.offerTimeSlot.list;
  }
  changeTime(e) {
    if (e && e.length > 0) {
      this.createTime.startTime = e[0];
      this.createTime.endTime = e[1];
    }
  }
  cancel() {
    (this.$refs.createTimeForm as any).resetFields();
    this.$emit("input", false);
  }

  async visibleChange(value: boolean) {
    if (!value) {
      this.id = 0;
      this.title = "添加时间段";
      this.$emit("input", value);
    } else {
      let data = util.extend(
        true,
        {},
        this.$store.state.offerTimeSlot.editOfferTimeSlot
      );
      if (data && data.id > 0) {
        this.title = "编辑时间段";
        this.createTime.startTime='';
        this.createTime.endTime='';
        this.id = data.id;
      }
    }
  }
  checkStartTime(rule: any, value: any, callback: any) {
    if (!this.createTime.startTime) {
      callback(new Error("请选择开始时间-结束时间"));
    } else {
      callback();
    }
  }

  createTimeRule = {
    startTime: [
      {
        required: true,
        validator: this.checkStartTime,
        trigger: "change",
      },
    ],
  };
}
